// Tabs
export const TOOLS_TAB = 'tools';
export const CHAT_TAB = 'chat';
export const OVERVIEW_TAB = 'overview';
export const DATA_TAB = 'data';
export const TRANSCRIPT_TAB = 'transcript';

// Tools
export const AIR_AMBULANCE_TOOL = 'air_ambulance';
